<div class="card tab-box">
    <div class="row user-tabs">
      <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
        <ul class="nav nav-tabs nav-tabs-bottom">
          <li class="nav-item">
            <button class="nav-link" [class.activetab]= "ishighlighted('projecttab')" mat-flat-button (click)="projectDetailsTab()">
              <mat-icon>list</mat-icon>
              Project Details </button>
          </li>
          <li class="nav-item">
            <button class="nav-link"  [class.activetab]= "ishighlighted('configurationtab')" mat-flat-button (click)="projectConfigurationTab()">
              <mat-icon>description</mat-icon>
              Project Configuration</button>
          </li>
        </ul>
      </div>
    </div>
  </div>